import { formatSmallNumber } from '@shared/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';

interface SmallNumberProps {
  value: number;
  formatter?: (n: number) => string;
  className?: string;
}

export default function SmallNumber({
  value,
  formatter = formatSmallNumber,
  className,
}: SmallNumberProps) {
  const formatted = formatter(value);
  const isApproximate = formatted.startsWith('<');

  if (isApproximate) {
    return (
      <TooltipProvider>
        <Tooltip delayDuration={200}>
          <TooltipTrigger asChild>
            <span className={className}>{formatted}</span>
          </TooltipTrigger>
          <TooltipContent>
            <p className="text-sm">{value.toPrecision(2)}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return <span className={className}>{formatted}</span>;
}
